export default {
  // 模块名称
  reserve: {
    // 按钮类
    button: {
      newplan: 'New plan',
      save: 'Save',
      reset: 'Reset',
      conform: 'Confirm',
      cancel: 'Cancel',
      prompt: 'Prompt',
      whole: 'All',
      search: 'Query',
      close: 'Close',
      review: 'Review',
      assign: 'Assign',
      frame: 'Choose',
      modify: 'Modify',
      disadled: 'Disabled ',
      abled: 'Enabled ',
      look: 'View details',
      delete: 'Delete',
      add: 'Add'
    },
    // 文字标签类
    label: {
      openperson: 'Enabling person',
      open: 'Is it enabled',
      class: 'Classification of plans',
      preplanname: 'Preplan name',
      classificationofplans: 'Classification of plans',
      preplanlevel: 'Preplan level',
      range: 'Priority range',
      to: 'to',
      ruleName: 'Rule name',
      ruleStatus: 'Status',
      no: 'No',
      name: 'Rule name',
      statusName: 'Status',
      priority: 'Priority',
      creator: 'Creator',
      createTime: 'Create time',
      modifier: 'Modifier',
      modifyTime: 'Modify time',
      subSystemNames: 'Subsystem',
      typeName: 'Type',
      optionsmenu: 'Operations',
      either: 'Whether or not ',
      eitherDel: 'Are you sure to delete',
      ruleFile: 'Linkage trigger log',
      dateRule: 'Date range',
      result: 'Result',
      alarmType: 'Alarm/event type',
      alarmDev: 'Device name',
      rulrDev: 'Linkage device',
      lookDetail: 'View',
      triggerTime: 'TriggerTime',
      alarmId: 'Alarm/event ID',
      alarmDevId: 'Code',
      alarmLevel: 'Alarm level',
      urgent: 'urgent',
      serious: 'serious',
      general: 'general',
      ordinary: 'common',
      fail: 'failure',
      succ: 'success',
      ruleCode: 'Trigger rule encoding',
      ruleNames: 'Trigger rule name',
      linkDeviceName: 'Linkage equipment',
      triggerName: 'Action',
      mixDev: 'Device',
      addDevice: 'Add device',
      addDevices: 'Device',
      alarmEvent: 'Alarm event type',
      content: 'Content:',
      DeviceName: 'Device name',
      up: 'Up',
      down: 'Down',
      sysNotice: 'System message notification',
      triggerRes: 'Result',
      ruleClean: 'Description',
      condition: 'Condition',
      order: 'Order',
      noData: 'No data',
      alarmCenter: 'Alarm',
      limit: 'Linkage management'
    },
    // 提示类
    placeholder: {
      preplannameStep: 'Please enter the plan step name',
      enterRule: 'Enter rule name',
      startTime: 'Start date',
      choosestartTime: 'Please select start date',
      endTime: 'End date',
      noticeMode: 'System message standard template',
      pleChoose: 'please choose',
      filter: 'Enter keywords to filter',
      preplanname: 'Please enter plan name',
      classificationofplans: 'Please enter the plan type',
      preplanlevel: 'Please enter plan level',
    },
    // 消息类
    message: {
      alarmType: 'Please select the alarm type',
      step: 'Please select plan steps',
      start: 'Start priority must enter a positive integer in the range 1-99999'  ,
      end: 'The closing priority must be entered with a positive integer in the range 1-99999'  ,
      startGebd: 'Start priority must be less than or equal to end priority' ,
      delSucc: 'Delete the success' ,
      calDel: 'Undelete' ,
      disableOne: 'The specified device cannot be the same as the linkage device' ,
      sysNoSet: 'System message notification is not set' ,
      smsNoSet: 'SMS message notification not set' ,
      noCheck: 'The action to be deleted is not selected' ,
      disableDel: 'Do you want to delete the selected action?' ,
      addMost: 'Up to 20 specified linkage devices are added to the same linkage rule' ,
      searcFail: 'Query failed' ,
      doing: 'Executing' ,
      doSuc: 'execution succeed' ,
      doFail: 'Execution failed' ,
      heigher: 'Please enter the priority (1-99999), the smaller the number, the higher the priority' ,
      parseInt: 'Priority input range is a positive integer from 1-99999' ,
      ruleNameLen: 'Rule name must be 4 to 50 characters' ,
      addruleSuc: 'Add linkage rule successfully' ,
      modifyRuleSuc: 'Modify linkage rule successfully.',
      almostFinish: 'Complete at least one trigger condition for one subsystem'

    },
    // 标题类
    title: {
      steplist: 'Plan steps list',
      list: 'List of alarm types',
      checktype: 'Alarm type selected',
      checkstep: 'Selected plan steps',
      alarm: 'alarm correlation',
      step: 'Plan steps',
      msg: 'Basic information',
      name: 'Fire emergency plan',
      addRule: 'New rule',
      ret: 'Return',
      noticeSet: 'Notification template settings',
      noticePerson: 'Notify personnel',
      sysNotice: 'System information',
      ruleDetail: 'Log details',
      ruleAction: 'Action',
      noteiceSet: 'Notification settings',
      addRules: 'New linkage rules',
      lookRule: 'View linkage rule details',
      modifyRule: 'Modify linkage rules'
    }
  }
}
